// Railway API Configuration
// All browser-side calls go through the Supabase Edge Function `railway-proxy`,
// which forwards to the ClearSlot Railway backend. This avoids cross-origin
// and Cloudflare restrictions when calling Railway directly from the browser.
export const API_BASE_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/railway-proxy`;

// API Endpoints
export const API_ENDPOINTS = {
  healthcheck: "/v1/healthcheck",
  score: (customerHash: string, platformId: string, identityScope: string) => 
    `/v1/score/${customerHash}?platform_id=${platformId}&identity_scope=${identityScope}`,
  bookingCreate: "/v1/booking/create",
  bookingCancel: "/v1/booking/cancel",
  eventNoShow: "/v1/event/no-show",
  billingSummary: "/v1/billing/summary",
  billingLedger: (limit: number = 50, offset: number = 0) =>
    `/v1/billing/ledger?limit=${limit}&offset=${offset}`,
} as const;
